import React from 'react';
import { Link } from 'react-router-dom';
import PublicPage from '../components/public/PublicPage';
import usePageTitle from '../hooks/usePageTitle';
import './PublicPages.css';

const NotFoundPage = () => {
  usePageTitle('Page not found');

  return (
    <PublicPage>
      <section className="pub-hero">
        <div className="public-container pub-narrow pub-center">
          <p className="pub-eyebrow">Error 404</p>
          <h1>We could not find that page</h1>
          <p className="pub-lead">
            The link may be old or mistyped. If someone sent you a link to apply for a property, ask them to send it again.
          </p>
          <div className="pub-actions pub-actions--center">
            <Link to="/" className="public-btn public-btn--primary">Go to the home page</Link>
            <Link to="/contact" className="public-btn public-btn--ghost">Contact us</Link>
          </div>
        </div>
      </section>
    </PublicPage>
  );
};

export default NotFoundPage;
